enum TiposNotificacion {
    solicitud_antecedentes = 0,
    creacion_expediente = 1,
    aprobacion_expediente = 2,
    prestador_prorroga = 4,
    presidente_prorroga = 5,
    aprobacion_prorroga = 6,
    rechazo_prorroga = 7,
    enviar_antecedentes = 8,
    cerrar_expediente = 9,
    firmar_resolucion = 10,
    apelacion_suseso = 12,
    // RFC4: notificación al fiscalizador cuando el Presidente devuelve el expediente.
    devolver_expediente = 13,
}

export default TiposNotificacion;